/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reason/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Reason({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/Inactivate/Content/Reason",
  invalid,
  onChange
  
}) {
let insuranceSubscriptionDeactivatedReasonValueData = fromData.useDataValue({ viewPath,
context: 'insurance_subscription',
path: 'deactivated_reason',
})
let insuranceSubscriptionDeactivatedReasonChangeData = fromData.useDataChange({ viewPath,
context: 'insurance_subscription',
path: 'deactivated_reason',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 data="insurance_subscription.deactivated_reason"
 validate="/Data/validate.js textInput"
 invalid={invalid}
 required={true}
 value={insuranceSubscriptionDeactivatedReasonValueData}
 onChange={insuranceSubscriptionDeactivatedReasonChangeData}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Reason"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 placeholder="Reason for inactivating this subscription."
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}